module.exports = __webpack_public_path__ + "media/flags/jm-f0713d34.svg";